import { Box, type BoxProps } from '@mui/material';
import { forwardRef } from 'react';
import { useCompareContext } from '../../Context';
import { MAXIMUM_COLUMNS_MOBILE, useCreditCardCompareColumnContext } from '../ColumnContext';
import { ImageContainer } from '../ProductCardWithStickyHeader/components/CardAndTitle';
import { CardAndTitleContainer } from '../ProductCardWithStickyHeader/components/CardAndTitle.container';
import { RemoveCardButtonContainer } from '../ProductCardWithStickyHeader/components/RemoveCardButton.container';
import { CommonSkeleton } from './components/CommonSkeleton';

type CardAndTitleSkeletonProps = {
  additionalContainerProps?: BoxProps;
  variant?: 'default' | 'compact';
};

export const CardAndTitleSkeleton = forwardRef<HTMLDivElement, CardAndTitleSkeletonProps>(
  ({ additionalContainerProps, variant = 'default' }, ref) => {
    const { anyLargeOfferTitle } = useCompareContext();
    const { index } = useCreditCardCompareColumnContext();
    const compact = variant === 'compact';

    return (
      <CardAndTitleContainer
        additionalProps={{
          display: { xs: index > MAXIMUM_COLUMNS_MOBILE - 1 ? 'none' : 'flex', md: 'flex' },
          flexDirection: 'column',
          ...additionalContainerProps,
        }}
        innerRef={ref}
      >
        {!compact && <RemoveCardButtonContainer />}
        <ImageContainer
          additionalProps={{
            width: { xs: 125, md: 175 },
            alignSelf: 'center',
            sx: theme => ({
              border: `1px dashed ${theme.palette.neutral.lighter}`,
              borderRadius: '10px',
            }),
            'data-testid': `skeleton-image-container${compact ? '-mobile' : ''}`,
            ...(compact && {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }),
          }}
          compact={compact}
        >
          {compact && (
            <span
              aria-hidden="true"
              data-testid="skeleton-add-icon-mobile"
              className="mask-icon mask-icon-add-circle"
              style={{ width: '40px', height: '40px', backgroundColor: '#D8D9DA' }}
            />
          )}
        </ImageContainer>
        {!compact && (
          <Box
            sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}
            data-testid="skeleton-name-container"
          >
            <CommonSkeleton width="80%" />
            {anyLargeOfferTitle && <CommonSkeleton width="40%" />}
          </Box>
        )}
      </CardAndTitleContainer>
    );
  },
);
